export type ClientRole = 'user' | 'backoffice' | 'admin';

export type Capability =
  | 'manageUsers'
  | 'resetPassword'
  | 'setPassword'
  | 'deleteUsers'
  | 'manageGrants'
  | 'viewSystems'
  | 'viewAudit'
  | 'viewEvents';

const ORDER: Record<ClientRole, number> = { user: 0, backoffice: 1, admin: 2 };

const CAPABILITIES: Record<ClientRole, ReadonlySet<Capability>> = {
  user: new Set<Capability>(['viewSystems']),
  backoffice: new Set<Capability>(['manageUsers', 'resetPassword']),
  admin: new Set<Capability>([
    'manageUsers',
    'resetPassword',
    'setPassword',
    'deleteUsers',
    'manageGrants',
    'viewSystems',
    'viewAudit',
    'viewEvents',
  ]),
};

const LABELS: Record<ClientRole, string> = {
  user: 'Read-only access',
  backoffice: 'Back office',
  admin: 'Administrator',
};

export function hasAtLeast(role: ClientRole | null | undefined, min: ClientRole): boolean {
  return !!role && ORDER[role] >= ORDER[min];
}

export function hasClientRole(role: ClientRole | null | undefined): role is ClientRole {
  return !!role && role in ORDER;
}

export function can(role: ClientRole | null | undefined, capability: Capability): boolean {
  return hasClientRole(role) && CAPABILITIES[role].has(capability);
}

export function roleLabel(role: ClientRole | null | undefined): string {
  return hasClientRole(role) ? LABELS[role] : 'No access';
}
